import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { UserIcon, UserCoupleIcon, UserGroupIcon } from '../../components';
import styles from './Participants.module.scss';
const ParticipantsIcon = ({ isCouple, isGroup }) => {
    if (isCouple) {
        return _jsx(UserCoupleIcon, { className: styles.icon });
    }
    if (isGroup) {
        return _jsx(UserGroupIcon, { className: styles.icon });
    }
    return _jsx(UserIcon, { className: styles.icon });
};
const Participants = ({ maxParticipants, label }) => {
    const isCouple = !!(maxParticipants && maxParticipants === 2);
    const isGroup = !!(maxParticipants && maxParticipants > 2);
    return (_jsxs("div", { className: classNames(styles.participantsWrapper, 'd-flex align-items-center'), children: [_jsx(ParticipantsIcon, { isCouple: isCouple, isGroup: isGroup }), _jsx("span", { className: "text-truncate", children: label })] }));
};
export { Participants };
